import { useContext, useEffect } from "react"
import { UserContext } from "../UserContext"

// In case you want to set the user in neither of components nor hooks, you can use this hook. NOT TESTED YET.
export const useRefreshTokenListener = () => {
  const { setUser } = useContext(UserContext)
  useEffect(() => {
    // Event handler function
    const handleRefreshToken = (event) => {
      // Call the provided onRefresh function with the event detail
      setUser(event.detail)
    }

    // Add event listener
    window.addEventListener("onRefreshToken", handleRefreshToken)

    // Clean up
    return () => {
      window.removeEventListener("onRefreshToken", handleRefreshToken)
    }
  }, [setUser])
}

// Function to dispatch the refreshToken event
export const dispatchRefreshTokenEvent = (detail) => {
  // Create the event with custom detail
  const event = new CustomEvent("onRefreshToken", { detail })
  window.dispatchEvent(event)
}

